import { Box, Image, Text } from "@chakra-ui/react";
import React from "react";

const Testimonial = ({ testimonialData }: any) => {
  return (
    <Box
      gap={{ base: "16px", md: "59px" }}
      display="flex"
      flexDir={{ base: "column", md: "row" }}
      alignItems="center"
      justifyContent="space-between"
    >
      <Box w={{ md: "30%" }}>
        <Image maxH="322px" src={testimonialData?.image} alt="" />
      </Box>
      <Box maxW={{ md: "70%" }}>
        <Text textStyle={{ base: "body1-md", md: "subtitle2" }}>
          {testimonialData?.text}
        </Text>
        <Text as="h5" textStyle="h5" color="#3470E4" mt="20px">
          {testimonialData?.name}
        </Text>
        <Text textStyle="body1-md" mt="4px">
          {testimonialData?.designation}
        </Text>
      </Box>
    </Box>
  );
};

export default Testimonial;
